// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__+Df+Z","formControl":"addForm_formControl__uzRJf","list":"addForm_list__Kl-cp","btnWrpper":"addForm_btnWrpper__VE9MP"};